<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.rollcall'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-if="gradeLevels.length === 0" class="flex flex-col mt-5">
            <EmptyState with-icon with-button>
                <template v-slot:button>
                    <AppButton element="InertiaLink" :href="meta.links.import_students" v-if="meta.can.create_students">
                        {{ $t('messages.import_students') }}
                    </AppButton>
                </template>
            </EmptyState>
        </div>
        <form action="" method="POST" v-else @submit.prevent="submit">
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-8">
                    <div class="sm:col-span-2">
                        <FormLabel :value="$t('messages.date')" for="date" />
                        <FormInput required id="date" v-model="form.date" type="date" name="date" class="mt-1" />
                        <FormError :value="form.errors.date" class="mt-2" />
                    </div>

                    <div class="sm:col-span-2">
                        <label for="country" class="block text-sm font-medium leading-5 text-gray-700">
                            {{ $t('messages.turn') }}
                        </label>
                        <div class="mt-1">
                            <div class="inline-flex items-center">
                                <input
                                    id="turn-morning"
                                    name="turn"
                                    type="radio"
                                    value="0"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                    v-model="form.turn"
                                />
                                <label for="turn-morning" class="ml-1 mr-3">
                                    <span class="block text-sm leading-5 font-medium text-gray-700">{{
                                        $t('messages.morning')
                                    }}</span>
                                </label>
                            </div>
                            <div class="inline-flex items-center">
                                <input
                                    id="turn-afternoon"
                                    name="turn"
                                    type="radio"
                                    value="1"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                    v-model="form.turn"
                                />
                                <label for="turn-afternoon" class="ml-1 mr-3">
                                    <span class="block text-sm leading-5 font-medium text-gray-700">{{
                                        $t('messages.afternoon')
                                    }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="meta.preferences.user_grade_levels">
                    <template v-slot:default="{ filteredGradeLevels }">
                        <div class="mb-2" v-for="gradeLevel in filteredGradeLevels" :key="gradeLevel.id">
                            <SubmitFormButton
                                v-for="group in gradeLevel.groups"
                                :key="group.id"
                                desired-action
                                @click="form.group_id = group.id"
                                class="mr-2"
                                :button-text="group.name"
                                :processing="form.processing && form.group_id === group.id"
                            />
                        </div>
                    </template>
                </GroupSelector>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import AppButton from '@/components/AppButton.vue';
import GroupSelector from '@/components/GroupSelector.vue';
import EmptyState from '@/components/EmptyState.vue';
import FormInput from '@/components/Forms/FormInput.vue';

export default {
    components: {
        FormInput,
        EmptyState,
        GroupSelector,
        AppButton,
        FormError,
        FormLabel,
        SubmitFormButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Select',
    props: ['meta', 'gradeLevels'],
    data() {
        return {
            form: this.$inertia.form({
                date: this.meta.defaults.date,
                group_id: null,
                turn: this.meta.defaults.turn,
            }),
        };
    },
    methods: {
        submit() {
            this.form.get(this.meta.links.create);
        },
    },
};
</script>
